import { useReactiveVar } from '@apollo/client';

import { userStateVar } from 'core/state/userState';
import { UserRole } from 'types';

import { visibleFor } from '../Palette/paletteRoles';
import { IntegrationTab } from './settingsLinks';
import {
  canOpenSettingsSection,
  RUNTIME_SETTINGS_ROLES,
  SettingsSectionId,
} from './settingsSections';

/**
 * ТЗ 0093 — видит ли пользователь «Роботы и расписания» (главные выключатели
 * администратора). Доменные страницы (SMS, робот блокировки, письма дофина)
 * ведут туда ссылкой ТОЛЬКО тех, кому раздел открыт: остальным ссылка
 * кончилась бы возвратом в хаб.
 */
export const useCanOpenMainSwitches = (): boolean => {
  const roles = (useReactiveVar(userStateVar).me?.roles ?? []) as UserRole[];
  return visibleFor(roles, RUNTIME_SETTINGS_ROLES);
};

/**
 * ТЗ 0093 — открыт ли пользователю раздел настроек (для «Интеграций» — его
 * вкладка). Гейт кнопок «Настройки …» на рабочих страницах.
 */
export const useCanOpenSettingsSection = (
  id: SettingsSectionId,
  integrationTab?: IntegrationTab,
): boolean => {
  const roles = (useReactiveVar(userStateVar).me?.roles ?? []) as UserRole[];
  return canOpenSettingsSection(roles, id, integrationTab);
};
